import { render } from "./CadastraEmpresa.vue?vue&type=template&id=62e29f0d"
import script from "./CadastraEmpresa.vue?vue&type=script&lang=js"
export * from "./CadastraEmpresa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__